var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPosterOneHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.01 53.36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    d: "M0 0h40.01v53.36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2da343",
    d: "M5.4 4.42h29.2v44.53H5.4z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MC4wMSA1My4zNiI+DQogIDxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPg0KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+DQogICAgICA8Zz4NCiAgICAgICAgPHJlY3Qgd2lkdGg9IjQwLjAxIiBoZWlnaHQ9IjUzLjM2IiBzdHlsZT0iZmlsbDogI2VkZWRlZCIvPg0KICAgICAgICA8cmVjdCB4PSI1LjQiIHk9IjQuNDIiIHdpZHRoPSIyOS4yIiBoZWlnaHQ9IjQ0LjUzIiBzdHlsZT0iZmlsbDogIzJkYTM0MyIvPg0KICAgICAgPC9nPg0KICAgIDwvZz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { SvgPosterOneHigh as ReactComponent };